module.exports = __webpack_public_path__ + "static/PlaceEarth-Concept-8f6e6a7230964adccf49495e611954f5.svg";